import URLSearchParams from '@ungap/url-search-params';
import entries from 'core-js/features/object/entries';
import fromEntries from 'core-js/features/object/from-entries';

import {
  AD,
  AD_ID,
  AF_ADVERTISING_ID,
  AF_ID,
  APP_VERSION_QSP,
  BAI,
  CH_PRO,
  CJEVENT,
  DATE_OF_BIRTH,
  DEVICE_ID,
  EMAIL,
  EMBEDDED,
  EXPERIENCE,
  FIRSTNAME,
  FORCE_PERSONA_STATUS,
  FORCED_EXPERIMENT,
  FORCED_EXPERIMENTS,
  LANDING_PAGE_ORIGIN,
  LASTNAME,
  MY_PAY,
  PACT_CB,
  PACT_CB2,
  PACT_SPOT_ME,
  PAI_AD_ID,
  PAI_AMOUNT,
  PAI_BONUS,
  PAY_FRIENDS_P2P_EXPERIMENT,
  PAY_FRIENDS_TOKEN,
  PERSONALIZATION_AD_CAMPAIGN_TYPE,
  PHONE,
  PRELOAD,
  PROMO_CODE,
  RECEIVER_LTO,
  RECEIVER_LTO_V1,
  RECEIVER_LTO_V2,
  RECEIVER_LTO_V3,
  RECEIVER_LTO_V4,
  REFERRAL_TOKEN,
  REWARDS_AD,
  SRC,
  SYNTHETIC_TEST,
  UNEMPLOYMENT_WIZARD,
  UTM_SOURCE,
  VALUE_PROP,
  WEB_SOURCE,
} from 'consts/queryParameterConsts';
import {
  AJS_ANONYMOUS_ID,
  INQUIRY_ID,
  PAI_TOKEN,
  PF_TOKEN,
  VERIFICATION_ID,
} from 'consts/storageConsts';

function _getQueryParams() {
  let queryParams = window.location.search;

  if (queryParams) {
    queryParams = new URLSearchParams(queryParams);
  }

  return queryParams;
}

export function getQueryParamFromUrl(queryParamKey) {
  const queryParams = _getQueryParams();

  return queryParams && queryParams.get(queryParamKey);
}

export function getQueryParamsObject() {
  const queryParams = _getQueryParams();
  return fromEntries(queryParams);
}

export const AD_CAMPAIGN_QSP = getQueryParamFromUrl(AD);
export const AD_ID_QSP = getQueryParamFromUrl(AD_ID);
export const AF_ADVERTISING_ID_QSP = getQueryParamFromUrl(AF_ADVERTISING_ID);
export const AF_ID_QSP = getQueryParamFromUrl(AF_ID);
export const AJS_ANONYMOUS_ID_QSP = getQueryParamFromUrl(AJS_ANONYMOUS_ID);

export const EMBEDDED_APP_VERSION = getQueryParamFromUrl(APP_VERSION_QSP);
export const EMBEDDED_DEVICE_ID = getQueryParamFromUrl(DEVICE_ID);
export const EMBEDDED_FIRST_NAME = getQueryParamFromUrl(FIRSTNAME);
export const EMBEDDED_LAST_NAME = getQueryParamFromUrl(LASTNAME);
export const EMBEDDED_PHONE = getQueryParamFromUrl(PHONE);
export const EMBEDDED_EMAIL = getQueryParamFromUrl(EMAIL);
export const EMBEDDED_DATE_OF_BIRTH = getQueryParamFromUrl(DATE_OF_BIRTH);
export const EXPERIENCE_QSP = getQueryParamFromUrl(EXPERIENCE);
export const CH_PRO_QSP = getQueryParamFromUrl(CH_PRO);
export const CJ_EVENT = getQueryParamFromUrl(CJEVENT);
export const FORCE_PERSONA_STATUS_QSP =
  getQueryParamFromUrl(FORCE_PERSONA_STATUS);
export const FORCED_EXPERIMENT_QSP = getQueryParamFromUrl(FORCED_EXPERIMENT);
export const FORCED_EXPERIMENTS_QSP = getQueryParamFromUrl(FORCED_EXPERIMENTS);
export const INQUIRY_ID_QSP = getQueryParamFromUrl(INQUIRY_ID);
export const IS_EMBEDDED = !!getQueryParamFromUrl(EMBEDDED);
export const IS_PRELOAD = getQueryParamFromUrl(PRELOAD);
export const IS_SYNTHETIC_TEST = getQueryParamFromUrl(SYNTHETIC_TEST);
export const IS_WEB_APP_SRC = !!getQueryParamFromUrl(WEB_SOURCE);

export const PAY_FRIENDS_TOKEN_QSP = getQueryParamFromUrl(PAY_FRIENDS_TOKEN);
export const PAY_FRIENDS_P2P_EXPERIMENT_QSP = getQueryParamFromUrl(
  PAY_FRIENDS_P2P_EXPERIMENT
);

export const REFERRAL_TOKEN_QSP = getQueryParamFromUrl(REFERRAL_TOKEN);
export const SRC_QSP = getQueryParamFromUrl(SRC);
export const UTM_SOURCE_QSP = getQueryParamFromUrl(UTM_SOURCE);
export const UNEMPLOYMENT_WIZARD_QSP =
  getQueryParamFromUrl(UNEMPLOYMENT_WIZARD);
export const VALUE_PROP_QSP = getQueryParamFromUrl(VALUE_PROP);
export const VERIFICATION_ID_QSP = getQueryParamFromUrl(VERIFICATION_ID);
export const LANDING_PAGE_ORIGIN_QSP =
  getQueryParamFromUrl(LANDING_PAGE_ORIGIN);

export const QUERY_PARAMS = _getQueryParams();
export const HAS_QUERY_PARAMS = !!entries(getQueryParamsObject()).length;

// Pay Anyone Incentives
export const PAI_AMOUNT_QSP = getQueryParamFromUrl(PAI_AMOUNT);
export const PAI_BONUS_QSP = getQueryParamFromUrl(PAI_BONUS);
export const PAI_AD_ID_QSP = getQueryParamFromUrl(PAI_AD_ID);
export const PAI_TOKEN_QSP = getQueryParamFromUrl(PAI_TOKEN);

// Pay Anyone/Friends Token
export const PF_TOKEN_QSP = getQueryParamFromUrl(PF_TOKEN);

// Personalization Ad Campaign Type
export const PERSONALIZATION_AD_CAMPAIGN_TYPE_QSP = getQueryParamFromUrl(
  PERSONALIZATION_AD_CAMPAIGN_TYPE
);
export const IS_CB_PACT = PERSONALIZATION_AD_CAMPAIGN_TYPE_QSP === PACT_CB;
export const IS_CB2_PACT = PERSONALIZATION_AD_CAMPAIGN_TYPE_QSP === PACT_CB2;
export const IS_ANY_CB_PACT = IS_CB_PACT || IS_CB2_PACT;
export const IS_SPOT_ME_PACT =
  PERSONALIZATION_AD_CAMPAIGN_TYPE_QSP === PACT_SPOT_ME;

export const PROMO_CODE_QSP = getQueryParamFromUrl(PROMO_CODE);

/** Boost Anyone QSPs */
export const BAI_QSP = getQueryParamFromUrl(BAI);

export const IS_REWARDS_AD = !!(
  AD_CAMPAIGN_QSP && AD_CAMPAIGN_QSP.includes(REWARDS_AD)
);

export const IS_EPA_AD = AD_ID_QSP?.indexOf('_epa') > -1;

/** Receiver LTO QSPs */
export const RECEIVER_LTO_AMOUNTS = {
  [RECEIVER_LTO_V1]: 125,
  [RECEIVER_LTO_V2]: 150,
  [RECEIVER_LTO_V3]: 175,
  [RECEIVER_LTO_V4]: 200,
};
export const RECEIVER_LTO_VALUE = getQueryParamFromUrl(RECEIVER_LTO);
export const RECEIVER_LTO_AMOUNT = RECEIVER_LTO_AMOUNTS[RECEIVER_LTO_VALUE];

/* MyPay-intent QSPs */
export const IS_MY_PAY_INTENT = !!(LANDING_PAGE_ORIGIN_QSP === MY_PAY);
